module.exports = __webpack_public_path__ + "img/Wasteland_3.80bbbcc3.png";